import { createContext, useContext } from "react";
import type { SIZES } from "../utils/constant";

export interface InputGroupContextValue {
  size?: typeof SIZES.LG | typeof SIZES.SM | typeof SIZES.MD;
}

const InputGroupContext = createContext<InputGroupContextValue>({});

export const InputGroupContextProvider = InputGroupContext.Provider;

export const InputGroupContextConsumer = InputGroupContext.Consumer;

export function useInputGroup() {
  return useContext(InputGroupContext);
}

export default InputGroupContext;
